import { combineReducers } from 'redux';

// IMPORT MODULE FILES

export default combineReducers({
  // EXPORT MODULE FILES
});